import logo from "./logo.jpg"

export default function Logo(props: any) {
  const styles = {
    maxWidth: "100%"
  }

  return (
    <a href="https://www.dopravanapaletach.cz/" target="_blank" rel="noreferrer">
      <img src={logo} alt={"Logo Doprava na paletách"} style={styles} {...props} />
    </a>
  )
}
